import {
    NotificationOptions,
    NotificationType,
} from '../../types/common/INotification';
import {
    PUSH_NOTIFICATION,
    POP_NOTIFICATION,
} from '../../constants/common/actions/notifications.constants';
import {
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
} from '../../constants/common/notifications.constants';

export const NotificationActions = {
    error,
    info,
    success,
    warning,
    popNotification,
};

function error(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_ERROR,
        message,
        timestamp,
        options,
    );
}

function info(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
    shouldTranslate: boolean = true,
    notificationTimeout?: number,
) {
    return pushNotification(
        NOTIFICATION_TYPE_INFO,
        message,
        timestamp,
        options,
        shouldTranslate,
        notificationTimeout,
    );
}

function success(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_SUCCESS,
        message,
        timestamp,
        options,
    );
}

function warning(
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
) {
    return pushNotification(
        NOTIFICATION_TYPE_WARNING,
        message,
        timestamp,
        options,
    );
}

function popNotification(timestamp: number) {
    return { type: POP_NOTIFICATION, payload: timestamp };
}

function pushNotification(
    type: NotificationType,
    message: string,
    timestamp?: number,
    options?: NotificationOptions,
    shouldTranslate: boolean = true,
    notificationTimeout?: number,
) {
    const _timestamp = timestamp || Date.now();
    return {
        type: PUSH_NOTIFICATION,
        payload: {
            type,
            message,
            timestamp: _timestamp,
            options,
            shouldTranslate,
            notificationTimeout,
        },
    };
}
